'use client';

import { FC, useMemo } from 'react';

import { documentToHtmlString, Options } from '@contentful/rich-text-html-renderer';
import { BLOCKS, Document, INLINES } from '@contentful/rich-text-types';

import { renderToString } from 'react-dom/server';

import { Link } from '../../../shared/link/link';

interface Props {
   content: { [key: string]: Document };
}

const options: Partial<Options> = {
   renderNode: {
      [INLINES.HYPERLINK]: (node, next) => renderToString(<Link href={node.data.uri}>{next(node.content)}</Link>),
      [BLOCKS.PARAGRAPH]: (node, next) => {
         if (
            node.nodeType === 'paragraph' &&
            (node.content.length === 0 || (node.content[0]?.nodeType === 'text' && node.content[0]?.value === '')) &&
            // prevent hyperlink from becoming <br />
            node.content[1]?.nodeType !== 'hyperlink'
         )
            return `<br/>`;
         return `<p>${next(node.content).replace(/\n/g, '<br/>')}</p>`;
      }
   }
};

export const LegalEntityInfoContent: FC<Props> = ({ content }) => {
   const languageKeys = useMemo(() => Object.keys(content), [content]);

   return languageKeys?.map((language) => (
      <div
         id={`entity-${language}`}
         key={`content-${language}`}
         dangerouslySetInnerHTML={{ __html: documentToHtmlString(content[language], options) }}
      />
   ));
};
